import { zyAuthor } from '@/lib/servers';

export interface MaUserPermissions {
    seeAllMAContent?: boolean;
    toggleAllMAContent?: boolean;
    isDeveloperAdmin?: boolean;
    [key: string]: boolean | undefined;
}

export interface MaUserConfiguration {
    permissions: MaUserPermissions;
    pinnedBooks: string[];
    pinnedSubjects: number[];
}

interface MaUserConfigurationResponse {
    success: boolean;
    permissions: MaUserPermissions;
    pinned_books: string[];
    pinned_subjects: number[];
}

interface SavePinnedBooksResponse {
    success: boolean;
    pinned_books: string[];
}

interface SavePinnedSubjectsResponse {
    success: boolean;
    pinned_subjects: number[];
}

interface SaveSeeAllMaContentResponse {
    success: boolean;
    permissions: MaUserPermissions;
}

export async function fetchMaUserConfiguration(): Promise<MaUserConfiguration> {
    const res = await zyAuthor.get<MaUserConfigurationResponse>('modern_authoring/user_configuration');
    return {
        permissions: res.permissions ?? {},
        pinnedBooks: res.pinned_books ?? [],
        pinnedSubjects: res.pinned_subjects ?? [],
    };
}

export async function savePinnedBooks(pinnedBooks: string[]): Promise<string[]> {
    const res = await zyAuthor.put<SavePinnedBooksResponse>('modern_authoring/user_configuration/pinned_books', {
        body: { pinned_books: pinnedBooks },
    });
    return res.pinned_books ?? [];
}

export async function savePinnedSubjects(pinnedSubjects: number[]): Promise<number[]> {
    const res = await zyAuthor.put<SavePinnedSubjectsResponse>('modern_authoring/user_configuration/pinned_subjects', {
        body: { pinned_subjects: pinnedSubjects },
    });
    return res.pinned_subjects ?? [];
}

export async function saveSeeAllMAContent(seeAllMAContent: boolean): Promise<MaUserPermissions> {
    const res = await zyAuthor.put<SaveSeeAllMaContentResponse>('modern_authoring/user_configuration/see_all_ma_content', {
        body: { see_all_ma_content: seeAllMAContent },
    });
    return res.permissions ?? {};
}
